module.exports = __webpack_public_path__ + "static/img/article_friend.c2fbe243.png";